var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7793 10.7198L8.28223 2.47125C8.05488 2.33223 7.79461 2.25629 7.52817 2.25125C7.26174 2.2462 6.99878 2.31224 6.76634 2.44256C6.5339 2.57288 6.34038 2.76277 6.20568 2.99271C6.07099 3.22264 6 3.48431 6 3.75079V20.2493C6.00022 20.5157 6.07135 20.7772 6.20609 21.0071C6.34083 21.2369 6.53433 21.4266 6.76669 21.5569C6.99906 21.6872 7.26192 21.7533 7.52826 21.7483C7.79461 21.7434 8.05484 21.6677 8.28223 21.5289L21.7793 13.2803C21.9986 13.1462 22.1797 12.9581 22.3054 12.7339C22.4311 12.5098 22.4971 12.2571 22.4971 12.0001C22.4971 11.7431 22.4311 11.4904 22.3054 11.2662C22.1797 11.042 21.9986 10.8539 21.7793 10.7198V10.7198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3cd74bad91025781d44faf828cba8544.svg";
export { ForwardRef as ReactComponent };